import React, { useState } from 'react';
import classnames from 'classnames';
import styles from './../styles.module.scss';
import { ModelList, ProjectData } from './types';
import { DataSourceHandler } from '@api/data-source-handler';
import { useSelector } from 'react-redux';
import { RootState } from '@store/types';
import { successAlert } from '@components/toastify/notify-toast';
import { DeleteConfirm } from './confirm';
import { MdDelete, MdEdit, MdFileCopy } from 'react-icons/md';
import { TooltipTop } from '@components/tooltips';
import { Flex } from '@components/ui/Flex';
import { InPageSpinner } from '@components/spinners/in-page-spinner';
import moment from 'moment';


type AssetListProps = {
  data: ModelList[];
  callModelList: () => void;
  setType: (x: string) => void;
  setSelectedAsset: (x: ModelList) => void;
  setCreateModelVisible: (x: boolean) => void;
  createModalVisible: boolean;
  setProjectData: (x: ProjectData) => void;
};

const AssetModelList: React.FC<AssetListProps> = ({ data, callModelList, setType, setCreateModelVisible, setSelectedAsset, setProjectData }) => {
  const { envVariables: Env } = useSelector((store: RootState) => store.AccountReducer);
  const [showDeletePopup, toggleDeletePopup] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<ModelList>({} as ModelList);
  const [isLoading, setIsLoading] = useState(false);

  const handleCardClick = (asset: ModelList, isCopy?: boolean) => {
    setIsLoading(true);
    // fetchModelDetails(Number(asset.id), isCopy || false);
    fetchProjectModelDetails(Number(asset.id), isCopy || false);
  };

  const handleClone = (asset: ModelList) => {
    setIsLoading(true);
    DataSourceHandler.CloneProjects(
      `${Env?.REACT_APP_PLATFORM_URL}/asset/api`,
      Number(asset.id),
      (response) => {
        if (response) {
          successAlert("Project cloned successfully!");
          callModelList(); 
          setIsLoading(false);
        }
      },
      (error: any) => {
        console.error("Error cloning project:", error);
        setIsLoading(false);
      }
    );
  };

   const handleViewProjectdata = (item: any) => {
           setProjectData(item);
        }


  const fetchModelDetails = async (id: number, isCopy: boolean) => {
    try {
      DataSourceHandler.fetchModelDetails(
        `${Env?.REACT_APP_PLATFORM_URL}/asset/api`,
        id,
        (response) => {
          if (response) {
            setType(isCopy ? 'copy' : 'edit')
            setSelectedAsset(response)
            setCreateModelVisible(true);
            setIsLoading(false)
          }
        }
      );
    } catch (error) {
      console.error("Error:", error);
      setIsLoading(false)
    }
  };

  const fetchProjectModelDetails = async (id: number, isCopy: boolean) => {
    try {
      DataSourceHandler.fetchModelProjectDetails(
        `${Env?.REACT_APP_PLATFORM_URL}/asset/api`,
        id,
        (response) => {
          if (response) {
            setType(isCopy ? 'copy' : 'edit')
            setSelectedAsset(response)
            setCreateModelVisible(true);
            setIsLoading(false)
          }
        }
      );
    } catch (error) {
      console.error("Error:", error);
      setIsLoading(false)
    }
  };
  

  const deleteModel = (selectedAsset: ModelList) => {
    if (selectedAsset) {
      // DataSourceHandler.deleteModel(`${Env?.REACT_APP_PLATFORM_URL}/asset/api`, Number(selectedAsset.id), () => {
      //   successAlert("Deleted Successfully.")
      //   toggleDeletePopup(false);
      //   callModelList();
      // });
      DataSourceHandler.deleteProject(`${Env?.REACT_APP_PLATFORM_URL}/asset/api`, Number(selectedAsset.id), () => {
        successAlert("Deleted Successfully.")
        toggleDeletePopup(false);
        callModelList();
      });
    }
  }

  const handleDelete = (selectedAsset: ModelList) => {
    setItemToDelete(selectedAsset);
    toggleDeletePopup(true);
  }

  if(isLoading){
    return (<Flex className="center"><InPageSpinner /></Flex>)
  }

  return (
    <div className={styles["assetList"]}>
      <ul className={classnames(styles['nifi_titles'])}>
        {data?.map((item, index) => (
          <li key={index}>
            <div>
              <div className={styles['key']}>Project Name</div>
              <div>{item.name}</div>
            </div>
            <div>
              <div className={styles['key']}>Created By</div>
              <div>{item.createdBy}</div>
            </div>
            <div>
              <div className={styles['key']}>Created Date</div>
              <div>{moment(item.created).utc().format('YYYY-MM-DD HH:mm')}</div>
            </div>
            <div className={styles['divider']}></div>
            <div className={styles['mt-0']}>
              <h2 className={styles['modDescription']}>
                <div>{item.description}</div>
              </h2>
            </div>
            <div className={styles['divider']}></div>
            <div className={styles.actions}>
              <TooltipTop title="Edit Project">
                <button
                  className={styles.actionButton}
                  onClick={() => handleCardClick(item)}
                >
                  <div className={styles.center}>

                    <MdEdit size={"24px"} />
                  </div>
                </button>
              </TooltipTop>
              <TooltipTop title="Clone Model">
                <button
                  className={styles.actionButton}
                  onClick={() => handleClone(item)}
                >
                  <div className={styles['center']}>
                    <MdFileCopy size={"24px"} />
                  </div>
                </button>
              </TooltipTop>
                 <TooltipTop title={item?.schema?.type === 'Asset Hierarchy'?"View Asset Hierarchy":"View Knowledge Graph"}>
                  <button
                    className={styles.actionButton}
                    onClick={() => handleViewProjectdata(item)}
                  >
                    <div className={styles.center}>
                      {item?.schema?.type === 'Asset Hierarchy'?<img src="/icons/asset-hierarchy.svg" alt="" />:<img src="/icons/knowledge-graph.svg" alt=""  width={24}/>}
                    </div>
                  </button>
                </TooltipTop>
              <TooltipTop title="Delete Project">
                <button
                  className={styles.deleteButton}
                  onClick={() => handleDelete(item)}
                >
                  <div className={styles.actionButton}>
                    <MdDelete size={"24px"} />
                  </div>
                </button>
              </TooltipTop>
            </div>
          </li>
        ))}
      </ul>
      <DeleteConfirm
        onConfirm={() => deleteModel(itemToDelete)}
        showModal={showDeletePopup}
        title={`Are you sure you want to delete the ${itemToDelete?.name || ""} Project?` //Model
        }
        toggleClose={() => {
          toggleDeletePopup(false);
        }}
      />
    </div>
  );
};

export default AssetModelList;
